<template>
  <div>

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->


    <!-- Form -->
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm6 md8> 
            <span class="headline">{{ formTitle }}</span>
          </v-flex>
          <v-flex xs12 sm6 md4> 
            <span class="headline">Project Budget Information</span>
          </v-flex>
        </v-layout>              
      </v-card-title>

      <div style=" color: green; font-weight: bold; margin-left: 15px;">
      Total Project GoB Amount {{TotalPjectAmount.gob_amount}}
      and IDA Amount {{TotalPjectAmount.ida_amount}}.
      /
      Previous Total Mid Term GoB Amount {{totalMidTamount.gob_amount}}
      and IDA Amount {{totalMidTamount.ida_amount}}.
      </div>

      <div v-if="ecoTotalAmount.eco_code" style=" color: red; font-weight: bold; margin-left: 15px;"><br>
      Total Project Budget GoB Amount = {{ecoTotalAmount.gob_amount}} and IDA Amount = {{ecoTotalAmount.ida_amount}} of Economic Code {{ecoTotalAmount.eco_code}}({{ecoTotalAmount.account_name}}) 
      </div>

      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md>
            <v-layout row wrap>
            <v-flex xs12 sm6 md8> 
              <v-layout row wrap>
                <!-- {{typeof(formSchema.finanacial_year)}} -->
     
              <!-- <v-flex xs12 sm6 md6>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'start_date', fieldValue:formSchema.start_date, label:'Start Date',required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'end_date', fieldValue:formSchema.end_date, label:'End Date',required:1,disabled:'1'}"
                  ref="setRange"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex> -->

                <v-flex xs12 sm6 md6>              
                  <v-autocomplete
                  v-model="formSchema.eco_code"
                  :items="ecoCodeList"
                  :loading="isLoading"          
                  item-text="eco_account_code"
                  item-value="ecoAccount_code"
                  label="Economic Code"                         
                  :rules="[v => !!v || 'Economic code is required !']"
                  required
                   @change="onChangeEcoCode(formSchema.eco_code)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                  label="Economic Code Name"
                  v-model="formSchema.account_name"
                  :rules="[v => !!v || 'Economic code name is required !']"
                  required
                  readonly
                  ></v-text-field>
                </v-flex>

                <!-- <v-flex xs12 sm6 md6>              
                  <v-autocomplete
                  v-model="formSchema.unit_id"
                  :items="unitList"
                  item-text="name"
                  item-value="id"
                  label="Measurement Unit"                         
                  :rules="[v => !!v || 'Measurement unit is required !']"
                  required
                  ></v-autocomplete>
                </v-flex> -->

              <!-- <v-flex xs12 sm6 md6>
                <v-text-field
                label="Quantity"
                v-model="formSchema.quantity"
                :rules="[v => !!v || 'Quantity is required !']"
                required
                ></v-text-field>
              </v-flex> -->


              <v-flex xs12 sm6 md6>                
                <v-text-field
                :label="`GoB Amount Hin (${totalGoB_MidTamount})`"
                v-model="formSchema.gob_amount"
                :rules="[decimal]"
                @input="totalAmount"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>                
                <v-text-field
                :label="`IDA Amount Hin (${totalIDA_MidTamount})`"
                v-model="formSchema.ida_amount"
                :rules="[decimal]"
                @input="totalAmount"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Total Amount"
                v-model="formSchema.total_amount"
                :rules="[decimal]"
                readonly
                ></v-text-field>
              </v-flex>


              <v-flex xs12 sm6 md6 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex>

              <v-flex xs12 sm6 md12 >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
                    <v-icon>save</v-icon>
                    {{addUpdateBtn}}
                  </v-btn>
                  <v-btn color="error" @click.native="resetForm">
                    <v-icon>refresh</v-icon>Reset
                  </v-btn>
                </v-card-actions>
              </v-flex>


            </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md4 style="border:1px solid #CCC; text-align:center">
              Document Name :  {{proBudgetInfo.document_name}}<br>
              Financial Year From Date :  {{changeFormateDMY(proBudgetInfo.year_from_date)}}<br>
              Financial Year To Date  :  {{changeFormateDMY(proBudgetInfo.year_to_date)}}<br>
              File :  <!-- {{proBudgetInfo.document_file_name}} -->
                <a
                target="_blank"
                v-if="proBudgetInfo.document_file_name"
                title="Download"
                :href="`${public_path}${proBudgetInfo.document_file_name}`"
                download
                >
                <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>
              </a>
            </v-flex>
                      
          </v-layout>
        </v-container>
      </v-card-text>      
    </v-form>
  </v-card>
  <!-- /Form -->
</div>
</template>


<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";
import ServerPath from "../../../../server-path/server-path";
let utilities = require("../../../../utilities/utilities");

export default {
  props: ["formSchema",'totalMidTamount'],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    public_path: ServerPath.serverPath,
    is_activeVal: 1,
    isLoading: false,
    BudgetingYearList: utilities.getBudgetingYearList(),
    
    proBudgetInfo:{
      log_in_project_id:'',
      budget_date:'',
      document_name:'',
      upload_file_name:'',
      is_active:''
    },
    
    totalGoB_MidTamount:0,
    totalIDA_MidTamount:0,

    TotalPjectAmount:{
      gob_amount:0,
      ida_amount:0,
    },

    ecoTotalAmount:{
      eco_code:'',
      account_name:'',
      gob_amount:'',
      ida_amount:'',
    },

    unitList:[],
    ecoCodeList:[],

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Mid Term Budget Form" : "Add Mid Term Budget Form";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    this.totalGoB_MidTamount = this.totalMidTamount.gob_amount
    this.totalIDA_MidTamount = this.totalMidTamount.ida_amount

    let proId = sessionStorage.getItem("proId");     
    let data = this.$store.getters.GET_COMMON_DATA
    
    if(!data)
    {
      this.$router.push('/financial/mt-budget-framework');
    }
    
    commonService.getAllData("get-mid-term-pro-budDet-dropdown-data/"+proId).then(res => {
        this.ecoCodeList = res.ecoCodeList;
        this.unitList = res.unitList;
        this.proBudgetInfo = res.proBudgetInfo
        this.TotalPjectAmount = res.TotalPjectAmount
    });   

  },

  methods: {

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "start_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    validateBeforeSubmit(e) {
      var formSchema = {...this.formSchema};
      formSchema.proj_budget_id = sessionStorage.getItem("proId");
      
      formSchema.start_date = this.changeFormateYMD(
          formSchema.start_date
        ); 
      formSchema.end_date = this.changeFormateYMD(
          formSchema.end_date
        );      

      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService.updateFormData(formSchema, "mtbf-detail").then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
        } else {
          commonService.insertFormData(formSchema, "mtbf-detail").then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
        }
      }
    },

    totalAmount(){
      let formSchema = this.formSchema;
      let proAmount = this.TotalPjectAmount;
      let medAmount = this.totalMidTamount;        

      let gobTotal = parseFloat(formSchema.gob_amount||0) + parseFloat(medAmount.gob_amount||0);

      let idaTotal = parseFloat(formSchema.ida_amount||0) + parseFloat(medAmount.ida_amount||0);

      this.totalGoB_MidTamount = gobTotal;
      this.totalIDA_MidTamount = idaTotal;   

      if(proAmount.gob_amount < gobTotal)
      {                
        formSchema.eco_code='';
        formSchema.account_name='';
        formSchema.total_amount='';
        this.SnackbarVal.color = "error"; 
        this.SnackbarVal.message = "Cross the GoB amount ("+gobTotal+") limit of project GoB amount ("+proAmount.gob_amount+")"
        this.SnackbarVal.snackbar = true;
        formSchema.gob_amount = "";
      }

      if(proAmount.ida_amount < idaTotal)
      {       
        formSchema.eco_code='';
        formSchema.account_name='';
        formSchema.total_amount='';          
        this.SnackbarVal.color = "error"; 
        this.SnackbarVal.message = "Cross the IDA amount ("+idaTotal+") limit of project IDA amount ("+proAmount.ida_amount+")"
        this.SnackbarVal.snackbar = true;
        formSchema.ida_amount = "";
      }

      let gob_amount = (formSchema.gob_amount>0) ? parseFloat(formSchema.gob_amount) : 0;
      let ida_amount = (formSchema.ida_amount>0) ? parseFloat(formSchema.ida_amount) : 0;      
      formSchema.total_amount = (gob_amount + ida_amount).toFixed(3);


    },

    onChangeEcoCode(eco_code)
    {      
      //console.log('value = ', eco_code)
      
      commonService.getAllDataById(eco_code,"get-eco-code-wise-pro-amount").then(res =>{
        console.log('res = ', res);
        this.ecoTotalAmount = res;
      });   


      let pro_val = {'pjectId': sessionStorage.getItem("proId"), 'eco_code':eco_code, 'tl':2}
      commonService.dataByMulParameters(pro_val,"check-eco-code-exist").then(res => {
        if(res.count > 0)
        {
          this.formSchema.account_name = '';
          this.SnackbarVal.color = "error"; 
          this.SnackbarVal.message = "Economic code already exist"
          this.SnackbarVal.snackbar = true;
        }
      });   

      let ecoCode = '';
      if (eco_code) {
        ecoCode = this.ecoCodeList.filter(function(a) {
          return a.ecoAccount_code == eco_code;
        })[0].eco_account_name;
      }
      this.formSchema.account_name = ecoCode
    },

    resetForm(){
      this.formSchema.id = 0;
      this.$refs.form.reset();
    },

    close: function(data) {
      if (data.status == 1) {
        this.formSchema.id = 0;  
        this.resetForm();      
      }      
      this.$emit("emitForm", data);
    }
  }
};
</script>

<style scoped>
  .proTitle {
    color: #FFFFD8;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    background: #388e3c;
  }
</style>


// WEBPACK FOOTER //
// src/components/project_info/mid_term_project_budget/prject_bud_details/insertForm.vue